<template>
    <BaseModal
        v-model="model"
        size="sm"
        :title="$t('users.changeCurrentOrganisation')">
        <VForm
            v-slot="validation"
            @submit="saveUserCurrentOrganisation">
            <BaseAlert
                color="warning"
                class="mb-4">
                {{ $t('users.changeCurrentOrganisationDescription') }}
            </BaseAlert>
            <BaseSelect
                v-model="currentOrganisationId"
                :label="$t('users.attributes.organisation')"
                :options="authStore.userData?.organisations"
                identifier="id"
                display-key="name"
                additional-display-key="sport_name" />
            <BaseSubmitButtons
                :validation="validation"
                :loading="loading"
                hide-cancel-button />
        </VForm>
    </BaseModal>
</template>

<script setup lang="ts">
import {useAuthStore} from '@/store/auth'

const authStore = useAuthStore()
const {$apiRoute} = useNuxtApp()
const notification = useNotification()
const {t: $t} = useI18n()

const props = defineProps({
    modelValue: {
        type: Boolean
    }
})

const emits = defineEmits(['update:modelValue'])

const currentOrganisationId = ref<number | null>(null)
const loading = ref<boolean>(false)

const model = computed({
    get: () => props.modelValue,
    set: (newValue) => {
        emits('update:modelValue', newValue)
    }
})

async function saveUserCurrentOrganisation() {
    if (!currentOrganisationId.value || !authStore.userData?.id || authStore.userData?.organisations.length <= 1) return
    loading.value = true

    const response = await $lara.put($apiRoute('spa.users.update', {
        user: authStore.userData?.id,
    }), {
        body: {
            current_organisation_id: currentOrganisationId.value,
            only: 'currentOrganisation',
        }
    })

    loading.value = false

    if (response?.error) return notification.error($t('users.couldNotBeSaved'))

    notification.success($t('users.savedSuccessfully'))

    await authStore.getAuthData()

    // reload the app to reload page data
    reloadNuxtApp({force: true})
}

onMounted(() => {
    currentOrganisationId.value = authStore.userData?.organisation_id ?? null
})
</script>